import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import messages from '../../../../../res/translations/messages';
import * as api from '../../../../services/api';

class ExternalProviderTester extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            loading: false,
            data: null,
        };
        this.startTest = this.startTest.bind(this);
    }

    async startTest() {
        this.setState({data: null, error: null, loading: true});
        try {
            const {data} = await api.testSurveyExternalProvider(this.props.values);
            this.setState({data});
        } catch (error) {
            this.setState({error});
        }
        this.setState({loading: false});
    }

    render() {
        return (
            <div>
                <button onClick={this.startTest} disabled={this.state.loading}
                    className={classNames('btn mr-3',
                        {'btn-primary': !this.state.error && !this.state.data, 'btn-success': !!this.state.data, 'btn-danger': !!this.state.error})}
                >
                    <FormattedMessage {...messages.surveys.form.externalProviderTest.testButton} />
                </button>
                {this.state.loading && <FormattedMessage {...messages.surveys.form.externalProviderTest.testing} />}
                {this.state.error && this.state.error.toString()}
                {this.state.data && this.props.children(this.state.data)}
            </div>
        );
    }
}

export default ExternalProviderTester;
